// import { makeStyles } from '@material-ui/core/styles';
import DeudasCliente from './Pages/DeudasCliente';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ConsultarDeudas from './Pages/ConsultarDeudas';
// const useStyles = makeStyles({
//   root: {
//     backgroundColor: '#e0e0e0',
//   },
// });
function App() {
  // const classes =  useStyles();
  return (
    <div >
      {/* <InfoDeudas></InfoDeudas> */}
      <Router>
        <Switch>
            <Route path="/" exact>
              <ConsultarDeudas></ConsultarDeudas>
            </Route>
            <Route path="/DeudaCliente">
              <DeudasCliente></DeudasCliente>
            </Route>
          </Switch>
      </Router>
     
    </div>
  );
}

export default App;
